import * as React from 'react';


export function createCustomContext<T>(defaultState?: () => Promise<T>) {
    const NewContext = React.createContext<
        {state?: T, setState: React.Dispatch<React.SetStateAction<T | undefined>>} | undefined
    >(undefined);

    function ContextContainer(props: { children: any }) {

        const [state, setState] = React.useState<T>()

        React.useEffect(() => {
                (async() => {
                    if(defaultState && typeof defaultState === 'function') {
                        setState(await defaultState())
                    }
                })().catch(() => {/** */});
        }, [])
        
        return (
            <NewContext.Provider value={{state, setState}}>
                { props.children }
            </NewContext.Provider>
        )
    }

    return { context: NewContext, container: ContextContainer };
}